"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#25D366",
    d: "M12.027 7.474a4.105 4.105 0 0 0-3.477 6.287l.098.155-.412 1.514 1.554-.408.149.089a4.105 4.105 0 1 0 2.089-7.638zm2.418 5.865a1.27 1.27 0 0 1-.833.586 2 2 0 0 1-.3.023 1.6 1.6 0 0 1-.478-.071l-.001-.001a7 7 0 0 1-.703-.26 5.5 5.5 0 0 1-2.108-1.863 2.4 2.4 0 0 1-.503-1.276 1.38 1.38 0 0 1 .432-1.031.45.45 0 0 1 .33-.154c.083 0 .165 0 .237.004h.028c.072 0 .161 0 .25.212.103.247.349.854.38.916.04.065.044.147.01.216a.8.8 0 0 1-.124.206c-.062.072-.129.161-.185.216-.062.061-.126.128-.054.252.185.317.417.605.686.855.292.261.628.469.992.614.124.062.195.052.267-.031s.309-.36.391-.484.165-.103.278-.062.72.34.843.401c.123.062.206.093.237.144.034.198.009.402-.072.586z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#25D366",
    d: "M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5m2.494 12.111a4.94 4.94 0 0 1-4.824.057l-2.621.685.701-2.559a4.938 4.938 0 1 1 6.743 1.817z"
  })]
}), 'WhatsappFilled');
